/**
 * Project: Aniatek
 * Author: Carlos A. Loaiza | Connect & Launch
 * Tel: +52 (667) 247 - 6316
 * Intellectual Property: All rights reserved (c) 2026
 */

<template>
  <div class="pdf-document-wrapper">

    <PageLayoutPDF>
      <div class="portada-container">

        <div class="hero-icon">
          <svg viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg" class="energy-drawing">
            <path
              d="M32 18C36.4183 18 40 14.4183 40 10C40 5.58172 36.4183 2 32 2C27.5817 2 24 5.58172 24 10C24 14.4183 27.5817 18 32 18Z"
              stroke="#1a202c" stroke-width="2" stroke-miterlimit="10" />
            <path d="M32 22V26M32 4V0M18 10H22M42 10H46M21 21L24 18M40 18L43 21M21 0L24 3M40 3L43 0" stroke="#1a202c"
              stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />

            <path d="M6 34L14 24H50L58 34M6 34H58M6 34L2 54H62L58 34" stroke="#1a202c" stroke-width="2"
              stroke-linecap="round" stroke-linejoin="round" />
            <path d="M16 24L14 34M28 24L24 34M36 24L40 34M48 24L50 34M18 34L16 54M30 34L28 54M46 34L48 54"
              stroke="#1a202c" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />

            <path d="M22 54V62M42 54V62" stroke="#1a202c" stroke-width="2" stroke-linecap="round" />
          </svg>
        </div>

        <div class="hero-text">
          <h1 class="welcome-title">Propuesta Energética Personalizada</h1>
          <p class="project-tagline">Hacia un futuro más rentable y sostenible</p>
        </div>

        <div class="main-project-card">
          <div class="project-header">
            <span class="label">PROYECTO:</span>
            <h2 class="project-name">{{ data.formData.nombreProyecto }}</h2>
          </div>

          <div class="project-details-grid">
            <div class="detail-item">
              <span class="detail-label">Preparado para:</span>
              <span class="detail-value">{{ data.formData.nombre }} {{ data.formData.apellidoPaterno }}</span>
            </div>
            <div class="detail-item">
              <span class="detail-label">Ubicación:</span>
              <span class="detail-value">{{ data.formData.localidadProyecto }}, {{ data.formData.estado_proyecto }}</span>
            </div>
            <div class="detail-item">
              <span class="detail-label">Fecha:</span>
              <span class="detail-value">{{ new Date().toLocaleDateString('es-MX', {
                year: 'numeric', month: 'long',
                day: 'numeric'
              }) }}</span>
            </div>
          </div>
        </div>

        <div class="impact-summary-grid">
          <div class="impact-card">
            <div class="impact-icon">⚡</div>
            <div class="impact-data">
              <span class="impact-val">{{ Number(data.formData.potenciaInstalar || 0).toFixed(2) }} kWp</span>
              <span class="impact-desc">Potencia Instalada</span>
            </div>
          </div>
          <div class="impact-card">
            <div class="impact-icon">💰</div>
            <div class="impact-data">
              <span class="impact-val">{{ formatCurrency(data.roiDetail[0]?.ahorro) }}</span>
              <span class="impact-desc">Ahorro Estimado Año 1</span>
            </div>
          </div>
          <div class="impact-card">
            <div class="impact-icon">💰</div>
            <div class="impact-data">
              <span class="impact-val">{{ formatCurrency(data.ahorroMensual) }}</span>
              <span class="impact-desc">Ahorro mensual.</span>
            </div>
          </div>
        </div>

      </div>
    </PageLayoutPDF>
    <PageLayoutPDF>
      <div class="resumen-proyecto-container">
        <h1 class="resumen-main-title">Resumen del Proyecto</h1>

        <div class="resumen-items-list">

          <div class="resumen-section-item">
            <h2 class="resumen-item-header">
              <span class="bullet-point">•</span> Objetivo del Proyecto
            </h2>
            <p class="resumen-paragraph">
              Proveer una solución de energía solar para su hogar mediante un sistema fotovoltaico interconectado a la
              red, diseñado con base en su historial de consumo eléctrico.
            </p>
          </div>

          <div class="resumen-section-item">
            <h2 class="resumen-item-header">
              <span class="bullet-point">•</span> Beneficio Económico
            </h2>
            <p class="resumen-paragraph">
              El sistema propuesto está dimensionado para generar ahorros desde el primer mes al reducir
              considerablemente su recibo de luz. Se estima un retorno de inversión en pocos años, con beneficios
              económicos a largo plazo.
            </p>
          </div>

          <div class="resumen-section-item">
            <h2 class="resumen-item-header">
              <span class="bullet-point">•</span> Beneficio Ambiental
            </h2>
            <p class="resumen-paragraph">
              Al aprovechar una fuente de energía limpia y renovable, este proyecto contribuye a disminuir su huella de
              carbono y apoyar la transición hacia un modelo energético más sustentable.
            </p>
          </div>

        </div>
      </div>
    </PageLayoutPDF>
    <PageLayoutPDF>
      <div class="consumo-historico-client-container">
        <h1 class="historico-main-title">Consumo Histórico</h1>

        <table class="historico-table-client">
          <thead>
            <tr>
              <th class="text-left">Mes</th>
              <th class="text-center">Consumo histórico (kWh)</th>
              <th class="text-right">Pago histórico a CFE ($)</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(item, index) in data.consumoHistorico" :key="index">
              <td class="text-left">{{ item.inicio }}</td>
              <td class="text-center">{{ (item.kwh).toLocaleString() }} kWh</td>
              <td class="text-right">{{ formatCurrency(item.pago) }}</td>
            </tr>
          </tbody>
          <tfoot>
            <tr class="total-row-client">
              <td class="text-left font-bold">Total</td>
              <td class="text-center font-bold">{{ totalKwh.toLocaleString() }} kWh</td>
              <td class="text-right font-bold">{{ formatCurrency(totalPago) }}</td>
            </tr>
          </tfoot>
        </table>

        <div class="historico-info-text">
          <p>
            La tabla anterior muestra el consumo energético y el costo del mismo, en un periodo anual comprendido, en el
            cual tuvo un gasto promedio de <span class="highlight-pago-negro">{{ formatCurrency(data.averagePago)
            }}</span> en energía eléctrica.
          </p>
        </div>
      </div>
    </PageLayoutPDF>
    <PageLayoutPDF>
      <div class="nuevo-consumo-container">
        <h1 class="nuevo-consumo-title">Nuevo Consumo (SFVI)</h1>

        <table class="nuevo-consumo-table">
          <thead>
            <tr>
              <th class="text-left">Mes</th>
              <th class="text-center">Energía Generada (kWh)</th>
              <th class="text-right">Nuevo Pago ($ MXN)</th>
              <th class="text-right">Ahorro por periodo ($ MXN)</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(item, index) in monthlySimulationData" :key="index">
              <td class="text-left row-header">{{ item.month }}</td>
              <td class="text-center">{{ Math.round(item.generation).toLocaleString() }} kWh</td>
              <td class="text-right">{{ formatCurrency(item.newPayment) }}</td>
              <td class="text-right">{{ formatCurrency(item.savings) }}</td>
            </tr>
          </tbody>
          <tfoot>
            <tr class="total-row-nuevo">
              <td class="text-left">Anual</td>
              <td class="text-center">{{ Math.round(totalAnnualGeneration).toLocaleString() }} kWh</td>
              <td class="text-right">{{ formatCurrency(totalAnnualNewPayment) }}</td>
              <td class="text-right">{{ formatCurrency(totalAnnualSavings) }}</td>
            </tr>
          </tfoot>
        </table>

        <div class="nuevo-consumo-summary">
          <p>
            El gasto promedio mensual proyectado es de<br>
            <span class="highlight-gasto-nuevo">{{ formatCurrency(averageMonthlyNewPayment) }}</span>
          </p>
        </div>
      </div>
    </PageLayoutPDF>
    <PageLayoutPDF>
      <div class="roi-full-container">
        <h1 class="roi-full-title">Retorno de Inversión</h1>

        <table class="roi-full-table">
          <thead>
            <tr>
              <th class="header-black">Mes</th>
              <th class="header-grey">Consumo Histórico (kWh)</th>
              <th class="header-grey">Energía Generada (kWh)</th>
              <th class="header-grey">Pago Histórico ($ MXN)</th>
              <th class="header-grey">Pago Nuevo ($ MXN)</th>
              <th class="header-black">Ahorro ($ MXN)</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(item, index) in combinedRoiData" :key="index">
              <td class="text-left font-bold">{{ item.month }}</td>
              <td class="text-center">{{ item.histKwh.toLocaleString() }}</td>
              <td class="text-center">{{ Math.round(item.genKwh).toLocaleString() }}</td>
              <td class="text-center">{{ formatCurrency(item.histPayment) }}</td>
              <td class="text-center">{{ formatCurrency(item.newPayment) }}</td>
              <td class="text-right font-bold">{{ formatCurrency(item.savings) }}</td>
            </tr>
          </tbody>
          <tfoot>
            <tr class="roi-total-row">
              <td class="text-left">Anual</td>
              <td class="text-center">{{ totalKwh.toLocaleString() }}</td>
              <td class="text-center">{{ Math.round(totalAnnualGeneration).toLocaleString() }}</td>
              <td class="text-center">{{ formatCurrency(totalPago) }}</td>
              <td class="text-center">{{ formatCurrency(totalAnnualNewPayment) }}</td>
              <td class="text-right">{{ formatCurrency(totalAnnualSavings) }}</td>
            </tr>
          </tfoot>
        </table>

        <div class="roi-footer-stats">
          <div class="roi-badge-red">
            <span class="roi-label">Retorno de inversión estimado (ROI)</span>

            <span class="roi-value">
              {{ data.tirRoi?.roiYears }} años

              <span v-if="data.tirRoi?.roiMonths && data.tirRoi.roiMonths > 0" style="font-size: 0.9em;">
                {{ data.tirRoi.roiMonths }} meses
              </span>
            </span>

          </div>
          <div class="roi-percentage-text">
            Con el SFVI obtendremos un ahorro del <span class="text-blue-bold">{{ percentageSavings }}%</span> del costo
            anual
          </div>
        </div>
      </div>
    </PageLayoutPDF>
    <PageLayoutPDF>
      <div class="presupuesto-client-container">
        <h1 class="presupuesto-main-title">Presupuesto</h1>

        <table class="presupuesto-table-client">
          <thead>
            <tr>
              <th class="text-center">Descripción</th>
              <th class="text-center">Total</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td class="text-left">Tamaño del sistema (W)</td>
              <td class="text-center">{{tamañoSistema.toLocaleString() }}</td>
            </tr>
            <tr>
              <td class="text-left">Tasa de Cambio</td>
              <td class="text-center">{{ data.formData.tipoCambio }}</td>
            </tr>
            <tr class="subtotal-row">
              <td class="text-left font-bold">Subtotal ($ MXN)</td>
              <td class="text-center font-bold">{{ formatCurrency(data.quoteTotals.grandSubtotal) }}</td>
            </tr>
            <tr>
              <td class="text-left">IVA ($ MXN)</td>
              <td class="text-center">{{ formatCurrency(data.quoteTotals.grandTotal - data.quoteTotals.grandSubtotal) }}
              </td>
            </tr>
          </tbody>
          <tfoot>
            <tr class="budget-total-row">
              <td class="text-left font-bold">Total ($ MXN)</td>
              <td class="text-center font-bold">{{ formatCurrency(data.quoteTotals.grandTotal) }}</td>
            </tr>
          </tfoot>
        </table>

        <div class="presupuesto-nota">
          <p>* Precios sujetos a cambios.</p>
        </div>
      </div>
    </PageLayoutPDF>
  </div>
</template>

<script>
import PageLayoutPDF from './PageLayoutPDF.vue';

export default {
  name: 'PDFCliente',
  components: { PageLayoutPDF },
  props: {
    data: Object
  },
  computed: {
    pagoMinimoCFE() {

      const precios = this.data.formData.precios_cfe || {};
      const tarifa = (this.data.formData.tarifaCFE || '').toUpperCase();

      if (tarifa.includes('DAC')) return precios.CARGO_FIJO_DAC || 135.00;
      if (tarifa.includes('PDBT')) return precios.PDBT?.CARGO_FIJO || 78.00;
      if (tarifa.includes('GDMTO')) return precios.GDMTO?.CARGO_FIJO || 474.54;
      if (tarifa.includes('GDMTH')) return precios.GDMTH?.CARGO_FIJO || 777.67;

      return 0;
    },

    totalKwh() {
      return this.data.consumoHistorico?.reduce((acc, item) => acc + (Number(item.kwh) || 0), 0) || 0;
    },
    totalPago() {
      return this.data.consumoHistorico?.reduce((acc, item) => acc + (Number(item.pago) || 0), 0) || 0;
    },
    tamañoSistema() {
      const kwp = Number(this.data.formData.potenciaInstalar) || 0;
      return kwp * 1000;
    },
    monthlySimulationData() {
      if (!this.data.consumoHistorico || this.data.consumoHistorico.length === 0) return [];

      const kwp = Number(this.data.formData.potenciaInstalar) || 0;
      const hsp = Number(this.data.formData.hspGuardado) || 5.0;
      const eficiencia = Number(this.data.formData.eficiencia || 75) / 100;

      const minimoCFE = this.pagoMinimoCFE;

      const diasPorMes = {
        "Enero": 31, "Febrero": 31, "Marzo": 31, "Abril": 31, "Mayo": 31, "Junio": 31,
        "Julio": 31, "Agosto": 31, "Septiembre": 31, "Octubre": 31, "Noviembre": 31, "Diciembre": 31
      };

      return this.data.consumoHistorico.map(item => {
        const nombreMes = item.inicio || 'Mes';
        const dias = diasPorMes[nombreMes] || (365 / this.data.consumoHistorico.length);
        const consumoKwh = Number(item.kwh) || 0;
        const pagoHist = Number(item.pago) || 0;

        const generacionMes = kwp * hsp * dias * eficiencia;

        let consumoNeto = consumoKwh - generacionMes;
        if (consumoNeto < 0) consumoNeto = 0;

        let proporcion = consumoKwh > 0 ? (consumoNeto / consumoKwh) : 0;
        let nuevoPago = pagoHist * proporcion;

        nuevoPago = minimoCFE + nuevoPago;

        let ahorro = pagoHist - nuevoPago;
        if (ahorro < 0) ahorro = 0;

        return {
          month: nombreMes,
          generation: generacionMes,
          newPayment: nuevoPago * 1.16,
          savings: ahorro,
          histKwh: consumoKwh,
          histPayment: pagoHist
        };
      });
    },

    totalAnnualGeneration() {
      return this.monthlySimulationData.reduce((acc, row) => acc + row.generation, 0);
    },

    totalAnnualNewPayment() {
      return this.monthlySimulationData.reduce((acc, row) => acc + row.newPayment, 0);
    },

    totalAnnualSavings() {
      return this.monthlySimulationData.reduce((acc, row) => acc + row.savings, 0);
    },

    averageMonthlyNewPayment() {
      if (!this.totalAnnualNewPayment) return 0;
      const numeroMeses = this.monthlySimulationData.length || 12;
      return (this.totalAnnualNewPayment / numeroMeses);
    },
    combinedRoiData() {
      return this.monthlySimulationData.map(item => ({
        ...item,
        genKwh: item.generation
      }));
    },

    percentageSavings() {
      if (!this.totalPago || !this.totalAnnualSavings) return 0;
      return ((this.totalAnnualSavings / this.totalPago) * 100).toFixed(1);
    }
  },
  methods: {
    formatCurrency(val) {
      return (val || 0).toLocaleString('es-MX', {
        style: 'currency',
        currency: 'MXN',
        minimumFractionDigits: 2
      });
    }
  }
};
</script>

<style scoped>
.portada-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100%;
  text-align: center;
  padding: 20mm 0;
}

.hero-icon {
  width: 80px;
  height: 80px;
  margin-bottom: 20px;
}

.welcome-title {
  font-size: 28px;
  font-weight: 800;
  color: #1a202c;
  margin-bottom: 5px;
  text-transform: uppercase;
  letter-spacing: 1px;
}

.project-tagline {
  font-size: 14px;
  color: #718096;
  margin-bottom: 40px;
}

.main-project-card {
  width: 90%;
  background: #f8fafc;
  border-left: 5px solid #29b9f6;
  border-radius: 8px;
  padding: 30px;
  text-align: left;
  margin-bottom: 40px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.02);
}

.project-header .label {
  font-size: 10px;
  color: #29b9f6;
  font-weight: 800;
}

.project-name {
  font-size: 24px;
  margin: 5px 0 20px 0;
  color: #1a202c;
}

.project-details-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 20px;
}

.detail-label {
  display: block;
  font-size: 10px;
  color: #a0aec0;
  text-transform: uppercase;
  margin-bottom: 4px;
}

.detail-value {
  font-size: 12px;
  font-weight: 600;
  color: #2d3748;
}

.impact-summary-grid {
  display: flex;
  gap: 15px;
  width: 90%;
}

.impact-card {
  flex: 1;
  display: flex;
  align-items: center;
  padding: 15px;
  background: white;
  border: 1px solid #e2e8f0;
  border-radius: 12px;
}

.impact-icon {
  font-size: 24px;
  margin-right: 12px;
}

.impact-data {
  display: flex;
  flex-direction: column;
  text-align: left;
}

.impact-val {
  font-size: 16px;
  font-weight: 800;
  color: #29b9f6;
}

.impact-desc {
  font-size: 9px;
  color: #718096;
  text-transform: uppercase;
  font-weight: 600;
}

.resumen-proyecto-container {
  padding: 15mm 5mm;
  text-align: left;
}

.resumen-main-title {
  font-size: 32px;
  font-weight: 800;
  color: #1a202c;
  margin-bottom: 40px;
  letter-spacing: -0.5px;
}

.resumen-items-list {
  display: flex;
  flex-direction: column;
  gap: 35px;
}

.resumen-section-item {
  max-width: 90%;
}

.resumen-item-header {
  font-size: 20px;
  font-weight: 700;
  color: #2d3748;
  margin-bottom: 10px;
  display: flex;
  align-items: center;
}

.bullet-point {
  color: #4a5568;
  margin-right: 12px;
  font-size: 24px;
}

.resumen-paragraph {
  font-size: 14px;
  line-height: 1.6;
  color: #4a5568;
  margin: 0;
  padding-left: 25px;
  text-align: justify;
}

.consumo-historico-client-container {
  padding: 10mm 5mm;
}

.historico-main-title {
  font-size: 28px;
  font-weight: 800;
  color: #1a202c;
  margin-bottom: 30px;
  letter-spacing: -0.5px;
}

.historico-table-client {
  width: 100%;
  border-collapse: collapse;
  margin-bottom: 25px;
}

.historico-table-client th {
  padding: 12px;
  color: #4a5568;
  font-size: 11px;
  font-weight: 700;
  text-transform: uppercase;
  border-bottom: 2px solid #edf2f7;
  background-color: #f8fafc;
}

.historico-table-client td {
  padding: 10px 12px;
  font-size: 11px;
  color: #2d3748;
  border-bottom: 1px solid #f1f5f9;
}

.total-row-client td {
  padding-top: 15px;
  border-top: 2px solid #edf2f7;
  border-bottom: none;
  font-size: 12px;
  color: #1a202c;
  background-color: #f8fafc;
}

.historico-info-text {
  margin-top: 30px;
  padding: 20px;
  background-color: #ffffff;
  border-left: 4px solid #1a202c;
  font-size: 14px;
  line-height: 1.6;
  color: #4a5568;
}

.highlight-pago-negro {
  font-weight: 800;
  color: #1a202c;
  font-size: 15px;
}

.text-left {
  text-align: left;
}

.text-center {
  text-align: center;
}

.text-right {
  text-align: right;
}

.font-bold {
  font-weight: 700;
}

.nuevo-consumo-container {
  padding: 10mm 5mm;
  text-align: center;
}

.nuevo-consumo-title {
  font-size: 32px;
  font-weight: 800;
  color: #1a202c;
  margin-bottom: 30px;
  letter-spacing: -0.5px;
}

.nuevo-consumo-table {
  width: 100%;
  border-collapse: separate;
  border-spacing: 0;
  margin-bottom: 30px;
  border: 2px solid #1a202c;
}

.nuevo-consumo-table th {
  padding: 12px;
  color: #ffffff;
  background-color: #2d3748;
  font-size: 11px;
  font-weight: 700;
  text-transform: uppercase;
  border-right: 1px solid #4a5568;
  border-bottom: 2px solid #1a202c;
}

.nuevo-consumo-table th:last-child {
  border-right: none;
}

.nuevo-consumo-table td {
  padding: 10px 12px;
  font-size: 12px;
  color: #2d3748;
  border-right: 1px solid #cbd5e0;
  border-bottom: 1px solid #cbd5e0;
  background-color: #ffffff;
}

.nuevo-consumo-table td:last-child {
  border-right: none;
}

.nuevo-consumo-table .row-header {
  background-color: #2d3748;
  color: #ffffff;
  font-weight: 700;
  text-transform: uppercase;
  border-right: 1px solid #4a5568;
}

.nuevo-consumo-table tbody tr:nth-child(even) td:not(.row-header) {
  background-color: #f7fafc;
}

.total-row-nuevo td {
  padding: 15px 12px;
  color: #ffffff;
  background-color: #1a202c;
  font-size: 13px;
  font-weight: 800;
  border-top: 2px solid #000000;
  border-right: 1px solid #4a5568;
}

.total-row-nuevo td:last-child {
  border-right: none;
}

.nuevo-consumo-summary {
  margin-top: 30px;
  font-size: 18px;
  color: #1a202c;
  font-weight: 600;
}

.highlight-gasto-nuevo {
  display: block;
  margin-top: 10px;
  font-weight: 800;
  color: #e53e3e;
  font-size: 28px;
}

.roi-full-container {
  padding: 5mm;
  text-align: center;
}

.roi-full-title {
  font-size: 28px;
  font-weight: 800;
  color: #1a202c;
  margin-bottom: 20px;
}

.roi-full-table {
  width: 100%;
  border-collapse: collapse;
  margin-bottom: 25px;
  font-family: sans-serif;
  table-layout: fixed;
}

.roi-full-table th {
  font-size: 8.5px;
  padding: 10px 4px;
  color: #ffffff;
  text-transform: uppercase;
  font-weight: 700;
  border: 1px solid #ffffff;
}

.header-black {
  background-color: #1a202c;
}

.header-grey {
  background-color: #4a5568;
}

.roi-full-table td {
  padding: 8px 4px;
  font-size: 9px;
  color: #2d3748;
  border-bottom: 1px solid #edf2f7;
}

.roi-full-table tbody tr:nth-child(even) {
  background-color: #f8fafc;
}

.roi-total-row td {
  background-color: #1a202c;
  color: #ffffff;
  font-weight: 800;
  font-size: 10px;
  padding: 12px 4px;
}

.roi-footer-stats {
  margin-top: 20px;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 15px;
}

.roi-badge-red {
  background-color: #2a2a2a;
  color: #ffffff;
  width: 100%;
  padding: 15px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-radius: 4px;
}

.roi-badge-red .roi-label {
  font-size: 16px;
  font-weight: 700;
  text-transform: uppercase;
}

.roi-badge-red .roi-value {
  font-size: 24px;
  font-weight: 800;
}

.roi-percentage-text {
  font-size: 16px;
  color: #2d3748;
  font-weight: 600;
}

.text-blue-bold {
  color: #29b9f6;
  font-weight: 800;
  font-size: 20px;
}

.presupuesto-client-container {
  padding: 15mm 10mm;
  text-align: center;
}

.presupuesto-main-title {
  font-size: 36px;
  font-weight: 800;
  color: #1a202c;
  margin-bottom: 40px;
  letter-spacing: -1px;
}

.presupuesto-table-client {
  width: 100%;
  border-collapse: collapse;
  margin-bottom: 30px;
  border: 1px solid #cbd5e0;
}

.presupuesto-table-client th {
  padding: 15px;
  font-size: 18px;
  color: #1a202c;
  background-color: #ffffff;
  border: 1px solid #cbd5e0;
  text-transform: capitalize;
}

.presupuesto-table-client td {
  padding: 12px 20px;
  font-size: 16px;
  color: #2d3748;
  border: 1px solid #cbd5e0;
}

.subtotal-row td {
  background-color: #f8fafc;
  color: #1a202c;
}

.budget-total-row td {
  padding: 18px 20px;
  font-size: 20px;
  border-top: 2px solid #29b9f6;
}

.budget-total-row td:last-child {
  color: #29b9f6;
  font-weight: 800;
}

.presupuesto-nota {
  margin-top: 40px;
  text-align: left;
  border-top: 1px solid #edf2f7;
  padding-top: 20px;
}

.presupuesto-nota p {
  font-size: 10px;
  color: #718096;
  margin: 4px 0;
  font-style: italic;
}

.text-left {
  text-align: left;
}

.text-center {
  text-align: center;
}

.font-bold {
  font-weight: 700;
}
</style>